import { REF_PATH as DELIVERY_TERM_REF_PATH }
  from '@/component/dict/simple/deliveryterm/Const';
import { REF_PATH as PACKING_REF_PATH }
  from '@/component/dict/simple/packing/Const';
import { REF_PATH as ORIGIN_REF_PATH }
  from '@/component/dict/simple/origin/Const';
import { REF_PATH as SELLER_REF_PATH }
  from '@/component/dict/simple/supplier/Const';
import { REF_PATH as PORT_REF_PATH }
  from '@/component/dict/simple/port/Const';
import { REF_PATH as BUYER_REF_PATH }
  from '@/component/dict/simple/buyer/Const';
import { REF_PATH as PRODUCER_REF_PATH }
  from '@/component/dict/simple/producer/Const';
import { REF_PATH as OWNER_REF_PATH }
  from '@/component/dict/simple/owner/Const';
import { REF_PATH as VESSEL_BROKER_REF_PATH }
  from '@/component/dict/simple/vesselbroker/Const';
import { REF_PATH as FORWARDER_REF_PATH }
  from '@/component/dict/simple/forwarder/Const';
import { REF_PATH as SHIPPINGLINE_REF_PATH }
  from '@/component/dict/simple/shippingline/Const';
import { REF_PATH as LOADING_TERM_REF_PATH }
  from '@/component/dict/simple/loadingterm/Const';
import { REF_PATH as BANK_REF_PATH }
  from '@/component/dict/simple/bank/Const';
import { REF_PATH as DOCUMENTTYPE_REF_PATH }
  from '@/component/dict/simple/documenttype/Const';
import { REF_PATH as INSURANCECOMPANY_REF_PATH }
  from '@/component/dict/simple/insurancecompany/Const';
import { REF_PATH as INSPECTIONCOMPANY_REF_PATH }
  from '@/component/dict/simple/inspectioncompany/Const';
import { REF_PATH as EXPENSECATEGORY_REF_NAME }
  from '@/component/dict/simple/expensecategory/Const';
import { REF_PATH as COMMONCOUNTERPARTIES_REF_PATH }
  from '@/component/dict/simple/commoncounterparties/Const';
import { REF_PATH as TRADECOUNTERPARTIES_REF_PATH }
  from '@/component/dict/simple/tradecounterparties/Const';
import { REF_PATH as TOPMANAGER_REF_PATH }
  from '@/component/dict/simple/topmanager/Const';
import { REF_PATH as PAYMENT_METHOD_REF_PATH }
  from '@/component/dict/simple/paymentmethod/Const';
// переехал в complex
import { REF_PATH as EXPENSESTYPE_REF_PATH }
  from '@/component/dict/complex/expensestype/Const';
import { REF_PATH as REGION_PATH }
  from '@/component/dict/simple/region/Const';
import { REF_PATH as PORT_GROUP_PATH }
  from '@/component/dict/simple/portgroup/Const';

export const dicts = [
  BUYER_REF_PATH,
  DELIVERY_TERM_REF_PATH,
  ORIGIN_REF_PATH,
  PACKING_REF_PATH,
  PORT_REF_PATH,
  SELLER_REF_PATH,
  EXPENSESTYPE_REF_PATH,
  OWNER_REF_PATH,
  VESSEL_BROKER_REF_PATH,
  FORWARDER_REF_PATH,
  SHIPPINGLINE_REF_PATH,
  LOADING_TERM_REF_PATH,
  BANK_REF_PATH,
  PRODUCER_REF_PATH,
  DOCUMENTTYPE_REF_PATH,
  INSURANCECOMPANY_REF_PATH,
  INSPECTIONCOMPANY_REF_PATH,
  EXPENSECATEGORY_REF_NAME,
  COMMONCOUNTERPARTIES_REF_PATH,
  TRADECOUNTERPARTIES_REF_PATH,
  REGION_PATH,
  TOPMANAGER_REF_PATH,
  PAYMENT_METHOD_REF_PATH,
  PORT_GROUP_PATH,
];
